/* ===========================================================================
   Autoplaying video, for somebody who asked their system to stop moving things.

   WHY THIS EXISTS

   The product page can autoplay a muted, looping video. That is the shop's
   choice and it stays. But a person who has set "reduce motion" has asked
   their operating system for exactly this not to happen, and no theme setting
   can know that, because Liquid renders before the browser is ever asked.

   WHY IT WORKS THE WAY IT DOES, WHICH IS NOT THE OBVIOUS WAY

   The first version of this file removed the `autoplay` attribute and paused
   the element. Measured: it did nothing at all. The theme's own video element
   starts playback from script and clears that attribute itself, so there was
   nothing to remove and the pause was immediately undone.

   So this listens for playback STARTING instead, and stops it if the visitor
   has not touched the page yet. A video that begins on its own is autoplay
   whatever started it; a video that begins after a tap is a person pressing
   play, and that is left alone.

   WHAT IT DELIBERATELY DOES NOT DO

   Nothing is hidden or removed: the poster, the controls and the video all
   stay, and one tap plays it. Embedded YouTube and Vimeo are untouched,
   because they play inside an iframe this page cannot reach into and claiming
   otherwise would be a comment describing something that does not happen.
   ========================================================================= */
(function () {
  var query;
  try { query = window.matchMedia('(prefers-reduced-motion: reduce)'); } catch (e) { return; }
  if (!query || !query.matches) return;

  /* Has the visitor done anything yet? The browser's own answer where it has
     one, and our own tracking where it does not. */
  var touched = false;
  var userStarted = function () {
    if (touched) return true;
    try {
      if (navigator.userActivation && navigator.userActivation.hasBeenActive) return true;
    } catch (e) {}
    return false;
  };
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { touched = true; }, { capture: true, passive: true });
  });

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    if (userStarted()) return;
    v.removeAttribute('autoplay');
    v.autoplay = false;
    /* Pausing can throw while the source is still resolving. A video that
       will not pause is not worth an error in somebody's console. */
    try { v.pause(); } catch (err) {}
  }, true);
})();
